"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkbox = void 0;
function checkbox(opts) {
    const readonly = 'onclick="return false;"';
    const checkboxFormatter = (row, cell, value, columnDef, data) => {
        if (data) {
            return value
                ? `<input type="checkbox" checked="checked" ${readonly}/>`
                : `<input type="checkbox" ${readonly}/>`;
        }
        return '';
    };
    checkboxFormatter.exportRawData = true;
    return checkboxFormatter;
}
exports.checkbox = checkbox;
//# sourceMappingURL=checkbox.js.map